import { Star, ArrowRight, PenLine } from "lucide-react";
import { GOOGLE } from "@/data/content";

const GoogleG = ({ size = 28 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden="true">
    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
  </svg>
);

export const GoogleReviews = () => {
  return (
    <section data-testid="google-reviews" className="py-16 sm:py-20 bg-[#f1f5f9] border-y border-slate-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="bg-white border border-slate-200 rounded-sm p-8 sm:p-10 grid lg:grid-cols-[auto_1fr_auto] gap-8 lg:gap-12 items-center">
          {/* Rating summary */}
          <div className="flex items-center gap-5">
            <GoogleG size={44} />
            <div>
              <div className="flex items-end gap-2">
                <span className="text-5xl font-extrabold font-display text-[#1c4f9c] leading-none">{GOOGLE.rating.toFixed(1)}</span>
                <div className="flex gap-0.5 mb-1">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} size={18} className="fill-[#fbbc05] text-[#fbbc05]" />
                  ))}
                </div>
              </div>
              <p className="mt-1 text-sm text-slate-500">Based on <span className="font-bold text-slate-700">{GOOGLE.count} Google reviews</span></p>
            </div>
          </div>

          {/* Snippet */}
          <div className="lg:border-l lg:border-slate-200 lg:pl-12">
            <div className="flex gap-0.5 mb-2">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={16} className="fill-[#fbbc05] text-[#fbbc05]" />
              ))}
            </div>
            <p className="text-base text-slate-700 font-medium leading-relaxed">"{GOOGLE.snippet}"</p>
            <p className="mt-1 text-xs text-slate-400">Verified Google review · 5+ years in business</p>
          </div>

          {/* CTAs */}
          <div className="flex flex-col gap-3 w-full lg:w-auto">
            <a
              href={GOOGLE.profileUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="read-reviews-btn"
              className="inline-flex items-center justify-center gap-2 bg-[#1c4f9c] text-white font-bold text-sm py-3 px-6 rounded-sm hover:bg-[#163d78] transition-colors duration-200 whitespace-nowrap"
            >
              Read Our Reviews <ArrowRight size={16} strokeWidth={2.5} />
            </a>
            <a
              href={GOOGLE.profileUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="leave-review-btn"
              className="inline-flex items-center justify-center gap-2 border-2 border-slate-200 text-[#1c4f9c] font-bold text-sm py-3 px-6 rounded-sm hover:border-[#1c4f9c] transition-colors duration-200 whitespace-nowrap"
            >
              <PenLine size={16} strokeWidth={2.5} /> Leave a Review
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
